import Overline from '@/components/ui/Overline/Overline';
import { BRAND_NAME } from '@/lib/brand';
import styles from './BrandLine.module.css';

type Props = {
  label?: string;
  page?: { current: number; total: number };
};

// 章扉ヘッダー。レポート上部のブランドライン（親ブランド＋成果物名＋タブラーのページ表示）。
export default function BrandLine({ label = '立地レポート', page }: Props) {
  return (
    <div className={styles.line}>
      <span className={styles.left}>
        <Overline className={styles.eyebrow}>{BRAND_NAME}</Overline>
        <span className={styles.name}>{label}</span>
      </span>
      {page && (
        <span className={styles.page}>
          {page.current} / {page.total}
        </span>
      )}
    </div>
  );
}
